import React, {FC} from 'react';
import {Link} from "react-router-dom";
import {Alert} from "react-bootstrap";
interface Props {
    data: any;
    atagParams: string | null
    mode?: string | null
}
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const QuickbetXLobbyComponent: FC<Props> = ({data,atagParams, mode}) => {
    let customTitle = window.location.host;
    return (
        <div className="col-12">
            {
                data.length > 0 ?
                    <div className="card smartbet-lobby-card mt-3">
                        {/*style={{color: '#005A70', fontWeight: '700'}}*/}
                        <div className="card-header">
                            {
                                customTitle === 'bet.mshikebet.co.ke' ?
                                    'BET TEKE'
                                    : 'QuickbetX'
                            }

                        </div>
                        <ul className='mt-3'>
                            {
                                data.length > 0 ?
                                    data.map((item: any, index: number) => {
                                        return (
                                            <li key={`${index}quickbetxsData`}>
                                                <Link
                                                    to={atagParams ? `quickbetx/${item.code}?atag=${atagParams}` : `quickbetx/${item.code}`}
                                                    className='smartbet-card-link text-decoration-none'
                                                    target={mode === 'iframe' ? '_blank' : undefined}
                                                >
                                                    <img
                                                        src={`${item.preview_img}`}
                                                        onError={(e) => { e.currentTarget.src = toAbsoluteUrl('/assets/img/events/league/F2964C.png'); }}
                                                        width='100' height='100' alt="sb-logo"
                                                    />
                                                    <span className='text-center text-green'>
                                                        {item.title.length > 0 ? item.title : null}
                                                    </span>
                                                </Link>
                                            </li>
                                        )
                                    }) : null
                            }
                        </ul>
                    </div>
                    : <Alert>Loading...</Alert>
            }
        </div>
    );

}

export default QuickbetXLobbyComponent;
